import React from "react";
import VoiceLingoComponent from "../components/VoiceLingoComponent";

const VoiceLingo = () => {
    return <VoiceLingoComponent />;
}

export default VoiceLingo;